import { useContext } from "react";
import { ToastContext } from "../context/ToastContext";
import { ToastType } from "../components/Toast/Toast";

export interface ToastOptions {
  type: ToastType;
  title?: string;
  message: string;
  duration?: number;
}

export const useToast = () => {
  const context = useContext(ToastContext);

  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }

  return context;
};
